<template>
    <abstract-dropdown-container v-model="selectedValue" :items="includeFreelancers ? [freelancersItem] : []" :options="{...defaultOptions, ...options}">
        <template v-slot:hint-top>
            <slot name="hint-top"></slot>
        </template>
        <template v-slot:hint-bottom>
            <slot name="hint-bottom"></slot>
        </template>
    </abstract-dropdown-container>
</template>

<script>
    import {SUPPLIERS_LIST as CRUD_ACTION_LIST} from 'actions/suppliers';

    export default {
        name: "FieldsDropdownSuppliers",
        props: {
            value: {},
            includeFreelancers: {
              type: Boolean,
              default: true
            },
            options: {
                type: Object,
                default: () => {}
            }
        },
        data() {
            return {
                selectedValue: this.value,
                freelancersItem : {
                    name: "Freelancers",
                    id: -1 // id = -1 is a magic constant to search for captains with no suppliers
                },
                defaultOptions: {
                    id:                                     "supplier_id",
                    prepareResponseDataHandler:             this.prepareResponseData,
                    customLabelHandler:                     this.customLabel,
                    action:                                 CRUD_ACTION_LIST,
                }
            }
        },
        watch: {
            value: function (newVal, oldVal) {
                this.selectedValue = newVal;
            },
            selectedValue: function (newVal, oldVal) {
                this.$emit('input', newVal);
            }
        },
        methods: {
            customLabel(value) {
                return `${value.name}`;
            },
            prepareResponseData(data) {
                return data;
            }
        }
    }
</script>

<style scoped>

</style>
